import { render } from "./VoteCardItemControl.vue?vue&type=template&id=11a34034"
import script from "./VoteCardItemControl.vue?vue&type=script&lang=js"
export * from "./VoteCardItemControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__